import { getUrlParameter } from 'common';
import cryptojs from 'crypto-js';
import sha256 from 'crypto-js/sha256';

export const registerPixels = (pixels) => {
  if (!Array.isArray(pixels)) {
    return;
  }

  const container = document.createElement('div');
  container.style.display = 'none';
  pixels.forEach((uri) => {
    let frame = document.createElement('iframe');
    frame.setAttribute('src', uri);
    frame.setAttribute('height', 1);
    frame.setAttribute('width', 1);
    container.appendChild(frame);
  });
  document.body.prepend(container);
};

const goog_snippet_vars = () => {
  var w = window;
  w.google_conversion_id = 922483525;
  w.google_conversion_label = 'yANjCO6nlW4QxfbvtwM';
  w.google_remarketing_only = !1;
};

export const goog_report_conversion = (url) => {
  goog_snippet_vars();
  window.google_conversion_format = '3';
  let opt = new Object();

  opt.onload_callback = () => {
    if (typeof url != 'undefined') {
      window.location = url;
    }
  };

  let conv_handler = window.google_trackConversion;

  if (typeof conv_handler == 'function') {
    conv_handler(opt);
  }
};

const eventCriteo = (props) => {
  if (typeof window.criteo_q !== 'object' || props.id === '') {
    return;
  }

  const { id, VisitIndex, EmailAddress } = props,
    source = getUrlParameter('utm_source') || '',
    criteo_id = props.criteo_id || 36673,
    criteo_bucket_limit = props.criteo_bucket_limit || 1;

  window.criteo_q.push(
    {
      event: 'setAccount',
      account: criteo_id,
    },
    {
      event: 'setSiteType',
      type: /iPad/.test(navigator.userAgent)
        ? 't'
        : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
            navigator.userAgent,
          )
        ? 'm'
        : 'd',
    },
    {
      event: 'setEmail',
      email: [EmailAddress],
    },
    {
      event: 'trackTransaction',
      deduplication: source.toLowerCase().indexOf('criteo') === -1 ? 0 : 1,
      id: id,
      item: [
        {
          id: '1',
          price: 0,
          quantity: 1,
        },
      ],
    },
  );

  setTimeout(() => {
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      {
        event: 'setAccount',
        account: criteo_id,
      },
      {
        event: 'viewHome',
      },
      {
        event: 'setData',
        ui_bucket:
          VisitIndex >= parseInt(criteo_bucket_limit)
            ? 'RepeatConverters'
            : 'Converters',
      },
    );
  }, 500);
};

const eventLiveIntent = (props) => {
  if (typeof window.liQ !== 'object') {
    return;
  }

  window.liQ = window.liQ || [];
  window.liQ.push({
    event: 'conversion',
    name: 'email_signup',
    email: props.EmailAddress,
  });
};

export const execute3rdPartyPixels = (props) => {
  if (!props.VisitIndex) {
    return;
  }

  props.VisitIndex = parseInt(props.VisitIndex);
  eventCriteo(props);
  eventLiveIntent(props);

  if (props.VisitIndex <= 40) {
    goog_report_conversion();
  }
};
